package fr.manyverse.app.domain.model

/**
 * Represents a sound/audio track available for playback.
 */
data class Sound(
    val id: String,
    val name: String,
    val fileName: String,
    val type: SoundType,
    val tags: Set<SoundTag>,
    val universeId: String,
    val userId: String? = null,
    val isUserUploaded: Boolean = false,
    val storagePath: String? = null,
    val durationSeconds: Int? = null
)

/**
 * Type of sound.
 */
enum class SoundType {
    MUSIC,
    EFFECT,
    AMBIENT
}

/**
 * Tags for filtering sounds.
 */
enum class SoundTag {
    CALM,
    TENSION,
    COMBAT
}
